<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      stroke="currentColor"
      stroke-width="1.5"
      d="M16 15v2H8v-2M5 7V3m14 4V3M3 3h4m10 0h4M2 7h20v14H2V7Zm7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    />
  </svg>
</template>
